<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/basic
ib-col(:class="{'insetx-16': $media.l, 'insetx-4': $media.s}", id="search-res")
    div(v-if="total > 0", class="flex-flex", :class="{'after-16': ids.length === 0}")
        ib-row
            ib-col
                div(class="before-16",
                    :class="{'outsetx-4': $media.xl, 'float-left': $media.xl, 'text-center': !$media.xl, 'after-8': !$media.xl}")
                    p(v-if="total > 0") {{ $t('showing') }}
                        span(v-if="curResults.length <= $num.int(total)", class="outsetx-4") {{ curResults.length }} {{ $t('of') }} {{ $num.int(total) }}
                        span(v-else, class="outsetx-4") {{ curResults.length }} {{ $t('of') }} {{ $num.int(total) }}
                        span(v-if="status === 'loading'")
                            ib-progress-circular(class="_ga_total_spinner", width="20px", height="20px")
    ib-row
        ib-col(id = "scroll", class="flex", style="max-height:65vh;")
            SearchTerm()
            ib-table-basic(
                :data="curResults",
                row,
                colborder
                rowstripe,
                class="fs7 fg70 shrink fin-table",
                spacing="huge",
                style="border: 1px solid rgba(0,0,0,0.15); overscroll-behavior:contain;",
                id="_ga-scroll-table"
            )
                ib-table-col(v-if="!$media.l", width="3ch", sticky)
                    div(class="border-bottom")
                    div
                        span(class="weighted text-right")
                ib-table-col(width="14ch", sticky)
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('name')")
                        span(:title="$t('company_name')") {{ $t('company_name') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'name' && sort.dir === 'asc' }",
                                @click.stop="sortResults('name', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'name' && sort.dir === 'desc' }",
                                @click.stop="sortResults('name', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(:title="$t('weighted_average')") {{ $t('weighted_average') }}
                ib-table-col(width="8ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('ticker')")
                        span(:title="$t('ticker')") {{ $t('ticker') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'ticker' && sort.dir === 'asc' }",
                                @click.stop="sortResults('ticker', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'ticker' && sort.dir === 'desc' }",
                                @click.stop="sortResults('ticker', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('country')")
                        span(:title="$t('country')") {{ $t('country') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'country' && sort.dir === 'asc' }",
                                @click.stop="sortResults('country', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'country' && sort.dir === 'desc' }",
                                @click.stop="sortResults('country', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="9ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('sector')")
                        span(:title="$t('sector')") {{ $t('sector') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'sector' && sort.dir === 'asc' }",
                                @click.stop="sortResults('sector', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'sector' && sort.dir === 'desc' }",
                                @click.stop="sortResults('sector', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="8ch")
                    div(:class="{'border-bottom': ids.length === 0}")
                        span(:title="$t('price')") {{ $t('price') }}*
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('mkt_nav')")
                        span(:title="$t('mkt_cap')") {{ $t('mkt_cap') + '/' + $t('nav') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'mkt_nav' && sort.dir === 'asc' }",
                                @click.stop="sortResults('mkt_nav', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'mkt_nav' && sort.dir === 'desc' }",
                                @click.stop="sortResults('mkt_nav', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ getFormat(averagesResponse.res[0].mkt_nav) }}
                ib-table-col(width="12ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('eps')")
                        span(:title="$t('eps')") {{ $t('eps') }} %
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'eps' && sort.dir === 'asc' }",
                                @click.stop="sortResults('eps', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'eps' && sort.dir === 'desc' }",
                                @click.stop="sortResults('eps', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ getGrowth(averagesResponse.res[0].eps) }}
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('div')")
                        span(:title="$t('div')") {{ $t('div') }} %
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'div' && sort.dir === 'asc' }",
                                @click.stop="sortResults('div', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'div' && sort.dir === 'desc' }",
                                @click.stop="sortResults('div', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(-1) > 0", class="fg-70 fg-primary text-right weighted")
                        span(v-else, class="fg-70 fg-primary text-right weighted") {{ getYield(averagesResponse.res[0].div) }}
                ib-table-col(width="7ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('pe')")
                        span(:title="$t('pe')") {{ $t('pe') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'pe' && sort.dir === 'asc' }",
                                @click.stop="sortResults('pe', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'pe' && sort.dir === 'desc' }",
                                @click.stop="sortResults('pe', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(-1) > 0", class="fg-70 fg-primary text-right weighted")
                        span(v-else, class="fg-70 fg-primary text-right weighted") {{ getFixed(averagesResponse.res[0].pe) }}
                ib-table-col(width="7ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('peg')")
                        span(:title="$t('peg')") {{ $t('peg') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'peg' && sort.dir === 'asc' }",
                                @click.stop="sortResults('peg', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'peg' && sort.dir === 'desc' }",
                                @click.stop="sortResults('peg', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(-1) > 0", class="fg-70 fg-primary text-right weighted")
                        span(v-else, class="fg-70 fg-primary text-right weighted") {{ getRatio(averagesResponse.res[0].peg) }}
                ib-table-col(width="8ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('ev')")
                        span(:title="$t('ev')") {{ $t('ev') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'ev' && sort.dir === 'asc' }",
                                @click.stop="sortResults('ev', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'ev' && sort.dir === 'desc' }",
                                @click.stop="sortResults('ev', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ getFormat(averagesResponse.res[0].ev) }}
                ib-table-col(width="7ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('rev')")
                        span(:title="$t('rev')") {{ $t('rev') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'rev' && sort.dir === 'asc' }",
                                @click.stop="sortResults('rev', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'rev' && sort.dir === 'desc' }",
                                @click.stop="sortResults('rev', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ setExchRev(averagesResponse.res[0].rev) }}
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('earnings')")
                        span(:title="$t('earnings')") {{ $t('earnings') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up",
                                :class="{'active-sort': sort.type === 'earnings' && sort.dir === 'asc' }",
                                @click.stop="sortResults('earnings', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'earnings' && sort.dir === 'desc' }",
                                @click.stop="sortResults('earnings', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(-1) > 0", class="fg-70 fg-primary text-right weighted")
                        span(v-else, class="fg-70 fg-primary text-right weighted") {{ setExchNI(averagesResponse.res[0].earnings) }}
                template(id="table_basic", slot="body", slot-scope="res")
                    td(class="padding-zero", v-if="!$media.l")
                        span(class="info results", @click="showResultModal(res)")
                            +icon-basic-info_filled
                    td(class="row_tracker", :data-conid="res['conid']", @click="getMoreInfo", :title="res['name']") {{ formatComp(res['name']) }}
                    td(
                        @click="getMoreDetails(res['company'], res['conid'])", 
                        :title="res['ticker']"
                    )
                        span(class="fg-accent") {{ res['ticker'] }}
                    td(@click="getMoreInfo", :title="res['country']", v-text="res['country']")
                    td(@click="getMoreInfo", :title="res['sector']", v-text="res['sector']")
                    td(@click="getMoreInfo", :title="res['conv_price']")
                        div(v-if="!res['conv_price']" class="spin")
                        span(v-else, class="text-right weighted") {{ res['conv_price'] }}
                    td(@click="getMoreInfo", class="text-right") {{ getFormat(res['mkt_nav']) }}
                    td(class="text-right") {{ getGrowth(res['eps_1y']) }}
                    td(class="text-right") {{ getYield(res['div_yield']) }}
                    td(@click="getMoreInfo", class="text-right") {{ getFixed(res['pe']) }}
                    td(@click="getMoreInfo", class="text-right") {{ getRatio(res['peg']) }}
                    td(@click="getMoreInfo", class="text-right") {{ getFormat(res['ev']) }}
                    td(class="text-right") {{ setExchRev(res['rev']) }}
                    td(@click="getMoreInfo", class="text-right") {{ setExchNI(res['earnings']) }}
                template(slot="foot")
                    LoadMore(v-if="ids.length === 0 && this.curResults.length > 0 && this.total - this.curResults.length > 1", @intersecting="loadMore")
    InfoModal(v-if="picked !== null", :picked="picked", :type="searchBy", ref="allInfoModal")
    DetailsModal(ref="detailInfoFour")
    ib-dialog(
        :autoclose="true",
        ref="modal",
        v-model="showLoginScreen"
        class="login-dialog"
    )
        div(class="inner-modal")
            div(class="add-info flex-fixed top")
                h3 {{ $t('login') }}
                a(@click="closeModal")
                    span(class="fg")
                        +icon-basic-cancel
            div(class="modal-body")
                h5(class="text-center") {{ $t('login_to_portal') }}
                p(class="text-center")
                    ib-button(class="bg-accent _btn act", @click.prevent="addFilters")  {{ $t('have_existing_account') }}
                br
                h5(class="text-center") {{ $t('no_account') }} {{ $t('open_one') }}
                p(class="text-center after-16")
                    a(class="bg-accent _btn act" href="https://www.interactivebrokers.com/en/index.php?f=4695") {{ $t('open_ib_account') }}
</template>

<script>

    import { mapState, mapActions } from 'vuex';
    import ChangeCurrency from './ChangeCurrency.vue';
    import InfoModal from './InfoModal.vue';
    import SearchTerm from './SearchTerm.vue';
    import LoadMore from './LoadMore.vue';
    import DetailsModal from './DetailsModal.vue';
    import { formatMixin } from '../js/formatting.js';
    import { priceMixin } from '../js/price';
    import { searchMixin } from '../js/search';

    const MAX_ROWS = 50;
    const sso = 'https://www.interactivebrokers.com/sso/Login';

    export default {
        name: 'SearchResultsCombined',
        components: {
            ChangeCurrency,
            InfoModal,
            SearchTerm,
            LoadMore,
            DetailsModal
        },
        // props: ['companies', 'countries', 'industries', 'range', 'filters', 'currency', 'responses', 'currencyConversions', 'showType', 'passComp', 'passInd', 'passAsset', 'averages'],
        // props: ['resultsResponse', 'averagesResponse'],
        mixins: [formatMixin, priceMixin, searchMixin],
        data() {
            return {
                curResults: [],
                total: 0,
                searchResults: [],
                show: false,
                showLoginScreen: false,
                curResultsMapping: new Map(),
                searchBy: 'All',
                type: 'stock',
                picked: null,
                sorting: false,
                loadingMore: false,
            }
        },
        methods: {
            loadMore(value) {
                if (this.loadingMore || !value) return;
                this.loadingMore = true;
                this.sorting = false;
                this.setCurrentPage(this.currentPage + 1);
                this.search({skipAvg: true});
                console.debug('Loading more...');
            },
            showResultModal(res) {
                this.picked = res;
                Vue.nextTick(()=> {
                    this.$refs.allInfoModal.show();
                })
            },
            addFilters() {
                window.location.href = `${sso}`;
            },
            closeModal() {
                this.showLoginScreen = false;
            },

            getMoreDetails(name, conid) {
                this.$refs.detailInfoFour.open(name, conid);
            },

            getMoreInfo() {
                if (!this.signedIn) {
                    this.showLoginScreen = true;
                }
            },

            // Creating the table output for each group
            processResponse() {
                if (this.resultsResponse.res.length <= 50) {
                    console.debug(this.resultsResponse.total);
                    document.getElementById('_ga-scroll-table').parentNode.scrollTo(0,0);
                }
                this.curResults = this.resultsResponse.res;
                this.loadingMore = false;
                this.total = this.resultsResponse.total;
                Vue.nextTick(() => {
                    this.initialized('#search-res', '.row_tracker', false);
                });
            },

            sortResults(type, dir) {
                console.log('Sorting Combined:', type, dir);
                if (this.sort.type && (this.sort.type === type && this.sort.dir === dir)) {
                    return;
                }
                if (this.ids.length > 0) {
                    return;
                }
                if (!dir) {
                    this.direction = !this.direction;
                    if (this.direction) {
                        dir = 'desc';
                    } else {
                        dir = 'asc';
                    }
                }
                this.sorting = true; // This will stop pageNumHandler
                this.setSorting({type,dir})
                this.setCurrentPage(1);
                this.curResultsMapping.clear();
                this.search({skipAvg: true});
            },
            ...mapActions(['setCurrentPage','setSorting', 'search'])
        },
        mounted() {
            this.processResponse();
        },
        computed : {
            /* Added the below 2 computed properties to avoid entire variable refactor. */
            resultsResponse: function() {
                return this.listedResults;
            },
            averagesResponse: function() {
                return this.averages;
            },
            ...mapState(['currentPage','currencyConversions', 'sort', 'marketDataPrices', 'ids', 'listedResults', 'averages', 'status']),
        },
        watch: {
            resultsResponse: {
                handler: function(newVal, oldVal) {
                    this.processResponse();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    ._con {
        svg {
            width: 1em;
            height: 1em;
        }
    }
    span {
        .up {
            position: relative;
            right: -6px;
            top: -6px;
            &.active-sort {
                color: #000;
            }
        }
        .down {
            position: relative;
            left: -5px;
            top: 4px;
            &.active-sort {
                color: #000;
            }
        }
    }
    .weighted {
        display: block;
    }
    .after_table {
        margin-bottom: 36px;
    }
</style>